import React, { useCallback, useContext, useState } from 'react';

interface ModalStateContext {
	addModal: (guid: string) => void,
	closeModal: (guid: string) => void,
	openedModalGuids: string[],
}

interface ModalProviderProps {
	children: JSX.Element,
}

const ModalContext = React.createContext<ModalStateContext>(null);
const useModalContext = (): ModalStateContext => useContext<ModalStateContext>(ModalContext);

function ModalProvider(props: ModalProviderProps): JSX.Element {
	const { children } = props;
	const [openedModalGuids, setOpenedModalGuids] = useState<string[]>([]);

	const addModal = useCallback((newModalId: string) => {
		setOpenedModalGuids((prevOpenedModalGuids) => {
			return [...prevOpenedModalGuids, newModalId];
		});
	}, []);

	const closeModal = useCallback((modalIdToClose) => {
		setOpenedModalGuids((prevOpenedModalGuids) => {
			return prevOpenedModalGuids.filter((id) => id === modalIdToClose);
		});
	}, []);

	// LATER: сейчас {addModal, closeModal, openedModalIds} никак не используются
	// сюда можно засунуть логику управления модалками через их id

	return (
		<ModalContext.Provider value={{addModal, closeModal, openedModalGuids}}>
			<div id="modal-container" />
			{children}
		</ModalContext.Provider>
	);
}

export {
	ModalProvider,
	useModalContext,
};